import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CategoryService } from "src/app/services/category.service";
import { EntityService } from "src/app/services/entity.service";
import { ReportService } from "src/app/services/report.service";

@Component({
  selector: "app-check-search",
  templateUrl: "./search-check.component.html",
  styleUrls: ["./search-check.component.css"],
})
export class SearchCheckComponent implements OnInit {

  @Output() onFilter = new EventEmitter<any>();
  @Output() onReset = new EventEmitter<any>();
  @Input() extraFields: any;
  statuses = ['PENDING', 'REJECTED', 'APPROVED'];
  queryFilter = {};
  panelOpenState = true;
  constructor(public categoryService: CategoryService, public entityService: EntityService,
    public reportService: ReportService
  ) {

  }

  resetFilter() {
    this.queryFilter = {}
    this.onReset.emit()
  }

  advancedSearch() {
    this.onFilter.emit(this.queryFilter)
    this.panelOpenState = false
  }

  ngOnInit() { }
}
